<div class="photo-edit" [ngStyle]="{ width, height }">
  <tui-avatar
    class="image"
    [ngStyle]="{ width, height, 'border-radius': borderRadius }"
    [src]="getPhotoUrl() | safe: 'url'"
    [size]="size"
    [round]="rounded"
    [tuiSkeleton]="loading"
  >
    <div class="image__background" (click)="onClickPhoto($event)"></div>

    <div class="file-input">
      <input
        #photoFileInput
        type="file"
        accept="image/png, image/jpeg"
        [attr.capture]="env.isAndroid ? 'user' : undefined"
        (change)="photoFileInputChange($event)"
      />
    </div>
  </tui-avatar>

  <app-icon
    *ngIf="!loading && getPhotoUrl()"
    class="delete-button"
    [size]="'20px'"
    [color]="'var(--tui-background-accent-2)'"
    [src]="'x'"
    [tuiHint]="'common.buttons.delete' | translate"
    (click)="onPhotoDelete()"
  ></app-icon>
</div>
